const getItemCategory = () => {
  const router = useRouter()

  const path = (String(router.options.history.state.back) || '')
    .split('/')
    .pop()

  switch (path) {
    case 'products':
      return 'products'
    case 'personalization':
      return 'personalization'
    case 'collabs':
      return 'collabs'
    case 'styles':
      return 'styles'
    case 'devices':
      return 'devices'
    default:
      return 'devices'
  }
}

export default getItemCategory
